module.exports = __webpack_public_path__ + "media/styles/images/png/filter-white-8bed88571cbaba31dbbde246e2a26301.png";